export default "__VITE_ASSET__BN8GOtvx__"